import React from "react";
import { Bot, Sparkles } from "lucide-react";

export function SellerAssistantLocked() {
  return (
    <div
      data-testid="seller-assistant-locked"
      className="glass rounded-3xl border border-white/10 flex flex-col flex-1 min-h-[520px] items-center justify-center p-8 text-center"
    >
      <div className="w-14 h-14 rounded-2xl bg-violet-500/10 flex items-center justify-center mb-4">
        <Bot className="w-7 h-7 text-violet-300" strokeWidth={1.5} />
      </div>
      <h2 className="font-heading text-lg font-light text-white flex items-center justify-center gap-2">
        Eladói asszisztens
        <Sparkles className="w-4 h-4 text-violet-400" strokeWidth={1.5} />
      </h2>
      <p className="text-sm text-slate-400 mt-3 max-w-md leading-relaxed">
        A chat és a megtekintés-naptár akkor érhető el, ha legalább egy hirdetéseden bekapcsolod az{" "}
        <span className="text-slate-200">AI ügyfélszolgálat</span> kiegészítőt — lent a hirdetésnél a
        kiegészítők között.
      </p>
    </div>
  );
}
